import React, { useEffect, useState } from "react";
import ChooseNFTPopup from "../ChooseNFTPopup/ChooseNFTPopup";
import UserNav from "../UserNav/UserNav";

const MemberButton = ({ user, setUser, setWallet }) => {
  const [open, setOpen] = useState(false);
  const [selectedNft, setSelectedNft] = useState("");
  useEffect(() => {
    setUser(selectedNft === "selected");
  }, [selectedNft, setUser]);
  return (
    <>
      <div className="flex gap-[7px]">
        {selectedNft === "selected" && user ? (
          <UserNav
            setWallet={setWallet}
            setSelectedNft={setSelectedNft}
            setUser={setUser}
            setOpen={setOpen}
          ></UserNav>
        ) : (
          <>
            <button className="bg-white w-[150px] h-[40px] rounded-[20px] text-[15px] font-bold text-[#0E0E0E]">
              0x7ga....25fp3
            </button>
            <div className="relative">
              <button
                onClick={() => setOpen((pre) => !pre)}
                className="nav-button-rounded"
              >
                Member Login
              </button>
              {open && (
                <ChooseNFTPopup
                  setOpen={setOpen}
                  setSelectedNft={setSelectedNft}
                ></ChooseNFTPopup>
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default MemberButton;
